import { connect } from 'react-redux';
import PainelDePagamentos from './painelDePagamentos';

export default connect()(PainelDePagamentos);
